import { FC } from 'react';
import { currencyParser, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import CreditSimulationSummary from './CreditSimulationSummary';
const CreditSimulationSummaryContainer: FC = () => {
  const navigate = useNavigate();
  const { creditProducts } = useStores();
  const { currentSimulationPlan } = creditProducts;

  const onSimulate = () => {
    navigate(Routes.CREDIT_SIMULATION_CONFIRMATION);
  };

  const onSimulateAgain = () => {
    navigate(Routes.CREDIT_SIMULATION_VALUE);
  };

  const items = {
    'Número de parcelas': `${currentSimulationPlan?.numberOfInstallments}x`,
    'Valor da Parcela': `${currencyParser(currentSimulationPlan?.installmentAmount || 0)}`,
    'Valor do IOF': `${currencyParser(currentSimulationPlan?.iofAmount || 0)}`,
    'Valor do Juros': `${currentSimulationPlan?.interestRate}% a.m.`,
    'Valor total a pagar': `${currencyParser(currentSimulationPlan?.totalAmount || 0)}`,
  };
  return (
    <CreditSimulationSummary
      items={items}
      onSimulate={onSimulate}
      onSimulateAgain={onSimulateAgain}
    />
  );
};
export default observer(CreditSimulationSummaryContainer);
